import React, { useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { Skeleton } from "antd";
import Table2 from "../../../components/Table";
import { useCandidates } from "../misc/useCandidate";
import { convertCandidatesToCandidatesType } from "../../../utility/candidateHelper";
import { CandidateType } from "../../../store/types/candidate";
import { delete_interview } from "../../../services/api/interview";
import { useAppDispatch } from "../../../store/hooks";
import DeleteConfirmModal from "../../../components/elements/DeleteConfirmModal";
import ModalNew from "../../../components/Modal/ModalNew";
import RescheduleModal from "../misc/RescheduleModal";
import { FilterTabs } from "../misc/FilterTabs";
import { ArrowLeft } from "lucide-react";

type User = {
  id: number | string;
  name: string;
  email: string;
  job: string;
  date: string;
  interviewDate?: string;
  status: string;
  actions: any;
};

const data: User[] = [
  {
    id: 1,
    name: "Ebenezer Ndukwe",
    email: "ebenezer.ndukwe@25thmail.com",
    job: "Frontend Engineer",
    date: "Mar 20, 2025",
    status: "Completed",
    actions: "Edit",
  },
];

const columns2: {
  header: string;
  accessor: keyof CandidateType;
  sortable: boolean;
}[] = [
  { header: "S/N", accessor: "id", sortable: true },
  { header: "Name", accessor: "name", sortable: true },
  { header: "Email", accessor: "email", sortable: true },
  // { header: "Job Title", accessor: "job", sortable: true },
  { header: "Interview Date", accessor: "date", sortable: true },
  { header: "Start Time", accessor: "interviewDate", sortable: true },
  { header: "Expires", accessor: "expirationDate", sortable: true },
  { header: "IV Status", accessor: "invitationStatus", sortable: true },
  { header: "Status", accessor: "recommendationStatus", sortable: true },
  { header: "Interview Status", accessor: "interviewStatus", sortable: true },
];

const InterviewCandidates: React.FC = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [editModal, setEditModal] = useState({
    isOpen: false,
    candidate: null as CandidateType | null,
  });

  const { id } = useParams();
  const jobId = id as string;
  // const candidateId = id as string;
  // const interviewId = id as string;
  const [error] = useState();
  const [selectedStatus, setSelectedStatus] = useState<string>("all");
  // const { candidate } = ViewInterview(interviewId, candidateId);
  const [deleteModal, setDeleteModal] = useState({
    isOpen: false,
    candidate: null as CandidateType | null,
  });
  const [isDeleting, setIsDeleting] = useState(false);

  const { candidates, loading, refetch } = useCandidates({
    page: "1",
    limit: "10",
    jobId,
    recommendationStatus: selectedStatus,
  });

  const convertedData = convertCandidatesToCandidatesType(candidates);
  console.log("Converted Data:", convertedData);

  if (error) {
    return (
      <div className="w-full">
        <div className="p-4">
          <div className="text-red-500">{error}</div>
          <Link
            to="/jobs"
            className="text-blue-600 hover:text-blue-800 mt-4 inline-block"
          >
            Back to Jobs
          </Link>
        </div>
      </div>
    );
  }

  // const handleRowClick = (row: User) => {
  //   navigate(
  //     `/reports/interview/evaluation?interviewId=${interviewId}&candidateId=${candidateId}`
  //   );
  // };

  const handleRowClick = (row: CandidateType) => {
    navigate(
      `/reports?interviewId=${row.interviewId}&candidateId=${row.candidateId}`,
    );
  };

  const handleEditClick = (row: CandidateType) => {
    console.log(row);
    setEditModal({
      isOpen: true,
      candidate: row,
    });
  };

  const handleRescheduleSuccess = () => {
    // Refetch the data to show updated information
    refetch();
    // Close the modal
    setEditModal({ isOpen: false, candidate: null });
  };

  const handleRowDelete = (row: CandidateType) => {
    console.log("Delete button clicked for:", row);
    setDeleteModal({
      isOpen: true,
      candidate: row,
    });
  };
  // Confirm delete
  const handleConfirmDelete = async () => {
    if (deleteModal.candidate) {
      console.log("Confirmed delete for:", deleteModal.candidate);
      setIsDeleting(true);
      try {
        await delete_interview(
          dispatch,
          deleteModal.candidate.interviewId,
          () => {
            // Refetch the data to show updated list
            refetch();
            // Close the modal
            setDeleteModal({ isOpen: false, candidate: null });
          },
        );
      } catch (error) {
        // Error is already handled in the API call
      } finally {
        setIsDeleting(false);
      }
    }
  };

  // Cancel delete
  const handleCancelDelete = () => {
    console.log("Delete cancelled");
    setDeleteModal({ isOpen: false, candidate: null });
  };

  const handleAddNewJob = () => {
    navigate("/create-interview");
  };

  // Handle filter change
  const handleStatusChange = (status: string) => {
    setSelectedStatus(status);
  };

  const [showMore, setShowMore] = useState(false);

  return (
    <div className="w-full py-5">
      <div className="max-w-[1096px] mx-auto px-3">
        <div className="flex items-center gap-4 mb-2">
          <div
            onClick={() => history.back()}
            className="text-blue-600 hover:text-blue-800 cursor-pointer"
          >
            <ArrowLeft className="w-6 h-6" />
          </div>
          <p className="font-[600]">Interviews newly created</p>
        </div>
        {/* Filter Tabs */}
        <FilterTabs
          selectedStatus={selectedStatus}
          onStatusChange={handleStatusChange}
          loading={loading}
        />
        <div className="flex justify-between items-center mt-2">
          <div className="flex items-end">
            <p className="font-[600]">List of interview for</p>
            {candidates?.slice(0, 1).map((item) => (
              <div className="flex items-end">
                <p className="text-lg font-[600] pl-1"> {item.jobTitle}</p>
                <p className="text-sm text-gray-600 pl-1">
                  {loading
                    ? "Loading..."
                    : `${candidates?.length || 0} interview(s)`}
                </p>
              </div>
            ))}
          </div>
          <button
            className="h-[45px] w-[150px] mt-[15px] flex items-center justify-center bg-secondary text-white rounded-lg hover:bg-secondary/90 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
            onClick={handleAddNewJob}
            // disabled={jobsLoading}
          >
            Add New Interview
          </button>
        </div>

        {loading ? (
          <Skeleton active paragraph={{ rows: 6 }} />
        ) : candidates ? (
          <div>
            <div>
              {candidates?.slice(0, 1).map((item) => (
                <div>
                  <p className="font-[500] pb-1">Job Description:</p>
                  <p className="pb-1">
                    {showMore
                      ? item.jobDescription
                      : `${item.jobDescription.substring(0, 100)}`}
                    {!showMore && "..."}
                    <button
                      onClick={() => setShowMore(!showMore)}
                      className="ml-1 text-blue-500 hover:text-blue-700"
                    >
                      {showMore ? " Read Less" : " Read More"}
                    </button>
                  </p>
                  {/* <p className="font-[500] pt-2 pb-1">Interview Questions:</p>
                <ul className="pb-1">
                  {item.interviewQuestions && item.interviewQuestions.map((question, index) => (
                    <li key={index}>{question}</li>
                  ))}
                </ul> */}
                </div>
              ))}
            </div>
            <Table2<CandidateType>
              data={convertedData}
              // data={convertedData}
              columns={columns2}
              onRowClick={handleRowClick}
              onEditClick={handleEditClick}
              onDeleteClick={handleRowDelete}
            />
          </div>
        ) : (
          <div className="text-center py-12 bg-gray-50 rounded-lg border border-gray-200">
            <p className="text-gray-500">No interview found for this job</p>
            <p className="text-sm text-gray-400 mt-1">
              Interviews will appear here once interviews are conducted
            </p>
          </div>
        )}

        <DeleteConfirmModal
          candidate={deleteModal.candidate}
          isOpen={deleteModal.isOpen}
          onConfirm={handleConfirmDelete}
          onCancel={handleCancelDelete}
          loading={isDeleting}
        />

        {/* Reschedule Interview Modal */}
        <ModalNew
          isOpen={editModal.isOpen}
          onClose={() => setEditModal({ isOpen: false, candidate: null })}
          title="Edit Candidate"
        >
          <RescheduleModal
            candidateData={editModal.candidate}
            isEditMode={true}
            onSuccess={handleRescheduleSuccess}
          />
        </ModalNew>
      </div>
    </div>
  );
};

export default InterviewCandidates;
